import React, { useState, useEffect } from "react";
import "./ProcessFlow.css";

function ProcessFlow() {
  const steps = [
    {
      id: 1,
      title: "Register Account",
      desc: "Create your admin login and company profile.",
    },
    {
      id: 2,
      title: "Create a Feedback Group",
      desc: "Design your request for anonymous feedback.",
    },
    {
      id: 3,
      title: "Send a Response Link",
      desc: "Send the unique link to your chosen recipients.",
    },
    {
      id: 4,
      title: "Responses Submitted",
      desc: "They fill out your feedback request anonymously.",
    },
    {
      id: 5,
      title: "Anonymous Storage",
      desc: "Responses go into our secure, anonymized database.",
    },
    {
      id: 6,
      title: "AI Summary",
      desc: "Our AI reviews data & sends you consolidated Key Bullet Points, Actionable Insights, Overall Summary, and Top Words.",
    },
  ];

  // currentIndex will track which step is actively highlighted
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    // Change the highlighted step every 5 seconds (5000ms)
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % steps.length);
    }, 5000);

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [steps.length]);

  return (
    <div className="process-flow-cycle-container">
      <h2 className="flow-title">Our Process</h2>

      {/* Render each step vertically with an arrow below (except the last arrow cycles back to the top) */}
      {steps.map((step, index) => {
        const isActive = index === currentIndex;
        const isLast = index === steps.length - 1;

        return (
          <div key={step.id} className="flow-step-block">
            <div className={`flow-step ${isActive ? "active-step" : ""}`}>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
            {/* Arrow pointing down to next step (or cycle back to start) */}
            {!isLast ? (
              <div className="flow-arrow">&#x2193;</div> // ↓
            ) : (
              <div className="flow-arrow cycle-arrow">&#x21A5;</div> // ⤥ or similar
            )}
          </div>
        );
      })}
    </div>
  );
}

export default ProcessFlow;
